export const IMPERSONATION_POPUP_FEATURES =
  'popup=yes,width=1440,height=900,left=100,top=50,resizable=yes,scrollbars=yes';

export const IMPERSONATION_CONFIG = Object.freeze({
  parent: Object.freeze({
    kind: 'parent',
    actionId: 'finance.parents.impersonate',
    permission: 'identity.parent-impersonation.start',
    startPath: '/api/v1/identity/admin/parent-impersonation/start',
    exchangePath: '/api/v1/identity/admin/parent-impersonation/exchange',
    targetField: 'parentId',
    windowNamePrefix: 'parent-cabinet',
    loadingPath: '/impersonation/loading',
    exchangeRoute: '/impersonation',
    startFailedPath: '/impersonation/start-failed',
    terminalPath: '/impersonation/terminal',
    expectedRole: 'parental-api',
    roleLabel: 'родителя',
  }),
  teacher: Object.freeze({
    kind: 'teacher',
    actionId: 'teachers.accounts.impersonate',
    permission: 'identity.teacher-impersonation.start',
    startPath: '/api/v1/identity/admin/teacher-impersonation/start',
    exchangePath: '/api/v1/identity/admin/teacher-impersonation/exchange',
    targetField: 'teacherId',
    windowNamePrefix: 'teacher-cabinet',
    loadingPath: '/impersonation/teacher/loading',
    exchangeRoute: '/impersonation/teacher',
    startFailedPath: '/impersonation/teacher/start-failed',
    terminalPath: '/impersonation/teacher/terminal',
    expectedRole: 'teaching-api',
    roleLabel: 'преподавателя',
  }),
});

export const getImpersonationConfig = (kind) => IMPERSONATION_CONFIG[kind] ?? null;

export const isIdentityUserId = (value) => (
  typeof value === 'string' &&
  value !== '00000000-0000-0000-0000-000000000000' &&
  /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i.test(value)
);

export const isImpersonationExchangeCode = (value) => (
  typeof value === 'string' && /^[A-Za-z0-9_-]{43}$/.test(value)
);
